// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8368 ? "2842c38e" : chunkId) + "." + {"1718":"ebb804ac38c11088","8368":"18e1f2002584800c"}[chunkId] + ".js";
};